// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__IA-Oe","icon":"Alert_icon__UB5ei"};